import React from 'react';
import { Router } from '@reach/router';
import {
  LocationServices,
  DialogServices,
  HandsFreeServices,
  IpAppInfoServices,
  UserPorfileServices,
  MusicServices,
  GeolocationServices,
  VisServices,
  KeyboardServices,
  SoundServices,
  PdfServices,
  // BleServices,
  WindowServices,
  NotificationServices,
  ScreenResolutionServices,
  Video,
} from '../screens/index';

const Navigation = () => (
  <Router>
    <UserPorfileServices path="/userProfile" />
    <LocationServices path="/location" />
    <DialogServices path="/dialog" />
    <HandsFreeServices path="/handsFree" />
    <IpAppInfoServices path="/ipappinfo" />
    <MusicServices path="/codecs" />
    <GeolocationServices path="/geolocation" />
    <VisServices path="/vis" />
    <KeyboardServices path="/keyboard" />
    <SoundServices path="/sounds" />
    <PdfServices path="/pdf" />
    {/* <BleServices path="/ble" /> */}
    <WindowServices path="/windowOpenClose" />
    <NotificationServices path="/notifications" />
    <ScreenResolutionServices path="/resolution" />
    <Video path="/video" />
  </Router>
);

export default Navigation;
